/** Help Center article URLs shared across form-survey-builder */
export const PRIMARY_COLOR_TOOLTIP_LEARN_MORE_URL =
  "https://help.leadconnectorhq.com/support/solutions/articles/155000008026-understanding-the-primary-color-in-forms-surveys-and-quizzes";
